<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Photos" />
            <DetailsPhoto />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import DetailsPhoto from './DetailsPhoto.vue';


export default {
    name: 'LesTuteursPage',
    components: {
        NavBar,
        PageTitle,
        DetailsPhoto,
        FooterComp,
    }
}
</script>